var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "p",
    {
      staticClass: "ob1-inline-promise",
      class: {
        "ob1-inline-promise-info": !_vm.isWarning,
        "ob1-inline-promise-warning": _vm.isWarning,
        "ob1-inline-promise-inverse": _vm.isBlack,
      },
    },
    [
      _vm.visuals.length
        ? _c(
            "span",
            { staticClass: "ob1-inline-promise-visual" },
            _vm._l(_vm.visuals, function (visual, index) {
              return _c("img", {
                key: visual.id || index,
                staticClass: "ob1-inline-promise-img",
                attrs: {
                  loading: "lazy",
                  src: visual.url,
                  alt: visual.alt,
                  "aria-hidden": "true",
                },
              })
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contentRows.length
        ? _c(
            "span",
            { staticClass: "ob1-inline-promise-content" },
            _vm._l(_vm.contentRows, function (row, index) {
              return _c("span", { key: `row-${index}` }, [
                row.title
                  ? _c("span", {
                      directives: [
                        {
                          name: "msh-html",
                          rawName: "v-msh-html",
                          value: row.title,
                          expression: "row.title",
                        },
                      ],
                      staticClass: "ob1-inline-promise-title",
                      class: { "ob1-inline-promise-small": _vm.compactText },
                    })
                  : _vm._e(),
                _vm._v(" "),
                row.title && row.text ? _c("br") : _vm._e(),
                _vm._v(" "),
                row.text
                  ? _c("span", {
                      directives: [
                        {
                          name: "msh-html",
                          rawName: "v-msh-html",
                          value: row.text,
                          expression: "row.text",
                        },
                      ],
                      staticClass: "ob1-inline-promise-standard",
                      class: { "ob1-inline-promise-small": _vm.compactText },
                    })
                  : _vm._e(),
              ])
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }